import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import csvHelper from '../reports/importjsontocsv';
import moveorderdetailsaccordian from '../moveorderdetailsAccordian'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'moveorderlist',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect,
		moveorderdetailsaccordian

	},
	props: [],
	data: function () {
		return {
			// currentPage: 0,
			// totalRows:0,
			show: false,
			isLoadingforxls: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listMoveOrderReportData: [],
			listunllocatedMoveOrderReportData: [],
			searchstatus: '',
			moveorderid: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			dataFilter : '',
			// pageLimit: 10,
			// pageno: 0,
			// totalPage: 0,
			POID: '',
			startdate: '',
			enddate: '',
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			racktype: '',
			startdateErr: '',
			enddateErr: '',
			recordLimit: 0,
			limitExeed: false,
			listMerchantData: [],
			MerchantList: [],
			merchantid: '',
			merchant: '',
			listMerchantData1: [],
			item: {},
			subinventory: '',
			viewmoveorder: false,
			pickerListData: '',
			selectAll: false,
			checkallflag: true,
			createdfrom: '',
			createdto: '',
			clientreferenceid: '',
			movefrom: '',
			moveto: '',
			fromDateErr: '',
			toDateErr: '',
			pickerid: '',
			SelectPickerErr: '',
			pickerAssignmentShow: false,
			length: '',
			orderids: [],
			loginuserid: '',
			viewMoveDetails: [],
			currentDate: '',
			totalRows1: 0,
			total: '',
			listsubinventoryData: [],
			filterData: {},
			selectedRow: {},
			showlist: true,
			tabIndex: 0,
			viewMoveDetailsList: [],
			show: false,
			download: true,
			dataFilter: {},
			dataFilter2: [],
			listMoveorderReportDataforxls: [],
			reportname1:'',
			show1:false,
			download1:true,
			listunllocatedMoveOrderReportDataxls:[],
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY hh:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction();
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.loginuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantList();
			this.getsubinventoryList();
			this.getPickersList();
		}

		switch (this.user_type) {
			case 'system_user':
   			this.loginUserEmail =userdetail.email;

				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.loginUserEmail =userdetail.email;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.getsubinventoryList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getPickersList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit();
		this.calldateFunction();
		this.reportname = this.$t('moveOrderList.moveOrderListReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportname1 = this.$t('moveOrderList.unallocatedMoveOrderDetails')
		this.reportname1 = this.reportname1 + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
	},
	methods: {
		showAddForm(data) {
			this.selectedRow = data
			this.showlist = false;
		},
		callParent() {
			this.showlist = true;
		},
		reset() {
			this.item = {}
		},

		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		calldateFunction: function () {

			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.enddate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.startdate = dt;
		},
		selectAllCheckbox: function () {
			if (this.checkallflag == true) {
				//this.rackIds = [];
				if (this.selectAll) {
					for (let order in this.listunllocatedMoveOrderReportData) {
						if (this.orderids.indexOf(this.listunllocatedMoveOrderReportData[order].orderid) == -1)
							this.orderids.push(this.listunllocatedMoveOrderReportData[order].orderid);
					}
				} else {
					for (let order in this.listunllocatedMoveOrderReportData) {
						if (this.orderids.indexOf(this.listunllocatedMoveOrderReportData[order].orderid) >= 0)
							this.orderids.splice(this.orderids.indexOf(this.listunllocatedMoveOrderReportData[order].orderid), 1);
					}
				}
			} else {
				this.$alertify.error(this.$t('common.disabledError'));
			}

		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.orderids = [];
				this.selectAll = false;
			} else { }
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		// Choosetype() {
		// this.show = true;
		// this.download = false;
		// if (!this.limitExeed) {
		// this.getMoveOrderlistReportDataForXls(3)
		// }
		// },
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
            let bstr = atob(base64);
            let n = bstr.length;
            let u8arr = new Uint8ClampedArray(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = {}) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.getMerchantList();
		// 		this.merchantid = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getsubinventoryList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.user_type == 'warehouse_user') {
		// 				this.warehouse = this.warehouseid;
		// 			}
		// 			if (this.warehouseid && this.clientid);
		// 			this.getPickersList();
		// 			this.getsubinventoryList();

		// 		}
		// 	}
		// 	this.listunllocatedMoveOrderReportData = [];
		// 	this.orderids = [];

		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	this.listunllocatedMoveOrderReportData = [];
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getPickersList();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getunallocatedMoveOrderList(csvCheck) {
			this.pickerAssignmentShow = false;
			this.searchFlag = true;


			var dataFilter = {};

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listunllocatedMoveOrderReportData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listunllocatedMoveOrderReportData = [];
				return false;
			}
			this.isLoading = true;

			if (this.createdfrom != '' || this.createdfrom != null || this.createdto != "" || this.createdto != null) {
				var months;
				var fromDate = new Date(this.createdfrom);
				var ToDate = new Date(this.createdto);
				months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))
				if (months > 3) {
					this.$alertify.error(this.$t('moveOrderList.createdDatedFilterErr'));
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listunllocatedMoveOrderReportData = [];
					return false;
				}
				if (fromDate > ToDate) {
					this.$alertify.error(this.$t('moveOrderList.createdDateGreaterErr'));
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listunllocatedMoveOrderReportData = [];
					return false;
				}
			}
			if (this.movefrom != '' || this.movefrom != null || this.moveto != "" || this.moveto != null) {
				var months;
				var fromDate = new Date(this.movefrom);
				var ToDate = new Date(this.moveto);
				months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))
				if (months > 3) {
					this.$alertify.error(this.$t('moveOrderList.selectedDatedFilterErr'));
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listunllocatedMoveOrderReportData = [];
					return false;
				}
				if (fromDate > ToDate) {
					this.$alertify.error(this.$t('moveOrderList.moveDateGreaterErr'));
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listunllocatedMoveOrderReportData = [];
					return false;
				}
			}

			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchantid,
				moveorderid: this.moveorderid.trim(),
				saleschannel: this.saleschannel,
				fromddate: this.dateFormat1(this.createdfrom),
				todate: this.dateFormat2(this.createdto),
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
				racktype: this.racktype,
				clientreferenceid: this.clientreferenceid,
				racksubinventory: this.subinventory,
				movefrom: this.dateFormat1(this.movefrom),
				moveto: this.dateFormat2(this.moveto),
				csvData :csvCheck

			})

			if (csvCheck == 2) {
				this.show1 = false;
				this.download1 = true;

			}
			else {
				this.show1 = true;
				this.download1 = false;

				}
			let value = '', str = ''
			this.dataFilter = {};
			this.dataFilter2 = [];
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
					this.dataFilter[k] = v;

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'unallocatedMoveOrderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.isLoading = false;

					if (csvCheck == 1) {
						this.download = false
						this.show = true;
						//this.dataFilter = {};

						this.listUnallocatedMoveorderReportDatacsv  = []
						this.csvFields = {
							'orderid': this.$t('common.moveOrderId'),
							'movedate': this.$t('pickPendingMoveOrder.table.columns.moveDate'),
							'totalitem': this.$t('moveOrderList.noOfSku'),
							'totalquantity': this.$t('moveOrderList.noOfQuantity'),
							// 'status': 'Status',
							// 'createdby': 'Created By',
							'createddate': this.$t('common.createdDateTime'),
							'racktype': this.$t('common.rackType'),
							'sourcesubinventory': this.$t('moveOrderList.sourceSubinventory'),
						};
 					 						var dateFilder = [];
 					 						var skipFilter = ['count','merchantname'];
						this.listUnallocatedMoveorderReportDatacsv = result.data.data.data[0].data

						this.jsonToCSV(this.$t('moveOrderList.unallocatedMoveOrderDetails')+ moment().format('DD-MM-YY_HH-mm-ss'), this.listUnallocatedMoveorderReportDatacsv, this.csvFields, dateFilder, skipFilter, this.dataFilter);

					} else if (csvCheck == 2) {
						this.listunllocatedMoveOrderReportData = result.data.data.data[0].data
						this.totalRows = Number(result.data.data.data[0].count)
						this.checkallflag = result.data.data.data[0].checkallflag
						this.resultCount = result.data.data.data[0].count

						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
							}
						}
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype2() {
			this.show1= true;
			this.download1 = false;
			this.getunallocatedMoveOrderListXls(3)
		},
		getunallocatedMoveOrderListXls(csvCheck){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.isLoading = true
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchantid,
				moveorderid: this.moveorderid.trim(),
				saleschannel: this.saleschannel,
				fromddate: this.dateFormat1(this.createdfrom),
				todate: this.dateFormat2(this.createdto),
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
				racktype: this.racktype,
				clientreferenceid: this.clientreferenceid,
				racksubinventory: this.subinventory,
				movefrom: this.dateFormat1(this.movefrom),
				moveto: this.dateFormat2(this.moveto),
				csvData :csvCheck

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'unallocatedMoveOrderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
							this.listunllocatedMoveOrderReportDataxls = [];
							this.csvFieldsForXls[this.$t('common.moveOrderId')]='orderid',
							this.csvFieldsForXls[this.$t('pickPendingMoveOrder.table.columns.moveDate')]='movedate',
							this.csvFieldsForXls[this.$t('moveOrderList.noOfSku')]='totalitem',
							this.csvFieldsForXls[this.$t('moveOrderList.noOfQuantity')]='totalquantity',
							this.csvFieldsForXls[this.$t('editedjson.CreatedDateTime')]='createddate',
							this.csvFieldsForXls[this.$t('common.rackType')]='racktype',
							this.csvFieldsForXls[this.$t('moveOrderList.sourceSubinventory')]='sourcesubinventory',
							this.listunllocatedMoveOrderReportDataxls = result.data.data.data[0].data

					}
					this.isLoading = false


				}, error => {
					console.error(error)
				})

		},

		getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},

		assignMoveOrderToPicker() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.pickerAssignmentShow = false;
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}
			if (this.pickerid == 0) {
				this.$alertify.error(this.$t('common.selectPickerErr'));
				return false;
			}
			if (this.orderids == 0) {
				this.$alertify.error(this.$t('common.selectAtLeastOneOrderErr'));
				return false;
			}
			// this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				selectedorder: this.orderids,
				userid: this.loginuserid,
				pickerid: this.pickerid,
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'assignMoveOrderToPicker',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.totalPage = this.totalPage - this.orderids.length
						this.$alert(result.data.data.msg, '', "success");

						this.getunallocatedMoveOrderList(2);
					} else {
						this.$alert(result.data.data.msg, '', "error");
					}
					this.isLoading = false;
					this.selectAll = false;
					this.pickerid = '';
					this.orderids = [];

				}, error => {
					console.error(error);
				});
		},

		getMoveOrderlistReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.listMoveOrderReportData= [];
			this.totalRows = 0;
			this.resultCount =0;

			this.getMoveOrderlistReportData(2);
		},
		getunallocatedMoveOrderListSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.unallocatedmoveOrderList = [];
			this.count = 0
			this.totalRows = 0;
			this.getunallocatedMoveOrderList(2);
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		dateFormatFRT1(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		},
		// getCsvDownload(check = 1) {
		// 	let dateFilter = [];
		// 	let skipFilter = ['count'];
		// 	if (check == 1){
		// 		this.jsonToCSV('MoveOrderList', this.listunllocatedMoveOrderReportData, this.csvFields, dateFilter, skipFilter, this.dataFilter);
		// 	}else{
		// 		csvHelper.data.jsonToCSV('unallocatedmoveOrderList', this.listunllocatedMoveOrderReportData, this.csvFields, dateFilter, skipFilter, this.dataFilter);
		// 	}
		//
		// },

		//to get client list
		getMoveOrderlistReportData(csvCheck) {
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}
			var dataFilter = {};

			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;

			}

			if (this.startdate == '' || this.startdate == null || this.enddate == "" || this.enddate == null) {
				this.startdateErr = this.$t('moveOrderList.createdStartDateErr');
				this.enddateErr = this.$t('moveOrderList.endDateErr');
				return false;
			}
			if (this.startdate != '' || this.startdate != null || this.enddate != "" || this.enddate != null) {
				var months;
				var fromDate = new Date(this.startdate);
				var ToDate = new Date(this.enddate);
				months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))
				if (months > 3) {
					this.$alertify.error(this.$t('common.dateError'));
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listMoveOrderReportData = [];
					return false;
				}
				if (fromDate > ToDate) {
					this.$alertify.error(this.$t('moveOrderList.startDateGreaterErr'));
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listMoveOrderReportData = [];
					return false;
				}
			}


			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchantid,
				moveorderid: this.moveorderid.trim(),
				searchstatus: this.searchstatus,
				fromDateFlt: this.dateFormat1(this.startdate),
				toDateFlt: this.dateFormat2(this.enddate),
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
				csvData: csvCheck,

			})
			let value = '', str = ''
			this.dataFilter = {};
			this.dataFilter2 = [];
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;

			}
			else {
				this.show = true;
			}

			this.filterData = this.input

			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.isLoading = false;
					if (result.data.data.data) {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
					//	this.dataFilter = {};
						this.listMoveOrderReportDataCsv = [];
						this.listMoveorderReportDataforxls= [];

						this.csvFields = {
							'moveorderid': this.$t('common.moveOrderId'),
							'noofsku': this.$t('moveOrderList.noOfSku'),
							'noofqty': this.$t('moveOrderList.noOfQuantity'),
							'status': this.$t('common.status'),
							'createdby': this.$t('common.createdBy'),
							'createddate': this.$t('common.createdDateTime'),
						};



						var dateFilder = [];
						var skipFilter = ['count'];

						this.listMoveorderReportDataforxls = result.data.data.data.orderData
						this.listMoveOrderReportDataCsv  = result.data.data.data.orderData
					///	alert(this.listMoveorderReportDataforxls.length);

							this.jsonToCSV(this.$t('moveOrderList.moveOrderListReport')+ moment().format('DD-MM-YY_HH-mm-ss'), this.listMoveOrderReportDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
					}else  {
						this.resultCount = 0;
						this.isLoading = false;
						this.listMoveOrderReportData = result.data.data.data.orderData
						this.viewMoveDetails = this.listMoveOrderReportData
						this.totalRows = Number(result.data.data.data.count)
						this.resultCount = result.data.data.data.count

						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
							}
						} else {
							this.totalPage = 0
						}
					}
       }
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getMoveOrderlistReportDataXls(3)
		},
		getMoveOrderlistReportDataXls(csvCheck = 3) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.isLoading = true

			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchantid,
				moveorderid: this.moveorderid.trim(),
				searchstatus: this.searchstatus,
				fromDateFlt: this.dateFormat1(this.startdate),
				toDateFlt: this.dateFormat2(this.enddate),
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
				csvData: csvCheck,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
							this.listMoveorderReportDataforxls = [];
							this.csvFieldsForXls[this.$t('common.moveOrderId')]='moveorderid',
							this.csvFieldsForXls[this.$t('moveOrderList.noOfSku')]='noofsku',
							this.csvFieldsForXls[ this.$t('moveOrderList.noOfQuantity')]='noofqty',
							this.csvFieldsForXls[this.$t('common.status')]='status',
							this.csvFieldsForXls[this.$t('common.createdBy')]='createdby',
							this.csvFieldsForXls[this.$t('common.createdDateTime')]='createddate',

							this.listMoveorderReportDataforxls = result.data.data.data.orderData

					}
					this.isLoading = false


				}, error => {
					console.error(error)
				})
		},
		allocateMoveOrder(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pickerAssignmentShow = false;
			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				moveorderid: data.moveorderid,
				useremail: this.loginUserEmail,
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'allocateMoveOrder',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						this.totalPage = this.totalPage - this.orderids.length
						this.$alert(result.data.data[0].msg, '', "success");
					} else {
						this.$alert(result.data.data[0].msg, '', "error");
					}
					this.getMoveOrderlistReportDataSearch();
					this.isLoading = false;
					this.selectAll = false;
					this.pickerid = '';
					this.orderids = [];

				}, error => {
					console.error(error);
				});
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		getsubinventoryList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSubInventoryList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listsubinventoryData = result.data;

					}
				}, error => {
					console.error(error)
				})
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getMoveOrderlistReportData(2)
		},
		onPageChange1(page) {
			this.currentPage = page;
			this.getunallocatedMoveOrderList(2)
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.orderids = [];
			this.show = false;
			this.download = true;
			this.searchstatus = '';
			this.startdate = null;
			this.enddate = null;
			this.merchantid = '';
			this.startdateErr = '';
			this.enddateErr = '';
			this.pageno = 0;
			this.pickerid = '';
			this.racktype = '';
			this.subinventory = '';
			this.createdfrom = null;
			this.createdto = null;
			this.clientreferenceid = '';
			this.movefrom = null;
			this.moveto = null;
			this.totalRows = 0;
			this.totalRows1 = 0;
			this.searchFlag = false;
			this.moveorderid = '';

			 document.getElementById('moveorderid').value = ''
			 document.getElementById('moveorderid1').value = ''

			this.listMoveOrderReportData = [];
			this.listunllocatedMoveOrderReportData = [];
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	this.clientid = '';
			// } else if (this.user_type == 'client_user') {
			// 	this.warehouse = '';
			// 	this.warehouseid = '';
			// } else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// 	this.clientid = '';
			// 	this.warehouseid = '';
			// }
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
		},
		resetSearchForm1() {
			this.moveorderid = '';
			this.orderids = [];
			this.show = false;
			this.download = true;
			this.searchstatus = '';
			this.startdate = null;
			this.enddate = null;
		//	this.moveorderid = '',
			this.merchantid = '';
			this.startdateErr = '';
			this.enddateErr = '';
			this.pageno = 0;
			this.pickerid = '';
			this.racktype = '';
			this.subinventory = '';
			this.createdfrom = null;
			this.createdto = null;
			this.clientreferenceid = '';
			this.movefrom = null;
			this.moveto = null;
			this.totalRows = 0;
			this.totalRows1 = 0;
			this.searchFlag = false;
			document.getElementById('moveorderid').value = ''
			this.listMoveOrderReportData = [];
			this.listunllocatedMoveOrderReportData = [];
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	this.clientid = '';
			// } else if (this.user_type == 'client_user') {
			// 	this.warehouse = '';
			// 	this.warehouseid = '';
			// } else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// 	this.clientid = '';
			// 	this.warehouseid = '';
			// }
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			this.calldateFunction();
		},

		onSelect(item) {
			this.item = item
			this.merchantid = item.value
		},
		viewrejectreson(data) {
			this.viewmoveorder = true;
			this.expanded = false,
			this.listunllocatedMoveOrderReportData = []
			this.viewMoveDetailsList = [];
			this.pickerAssignmentShow = false;
			this.searchFlag = true;

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				moveorderid: data.moveorderid.trim(),
			})

			this.filterData = this.input

			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderDetailsList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.data.status == true) {
						//this.resultCount = 0;
						this.isLoading = false;
						this.viewMoveDetailsList = result.data.data.data.orderData


					} else {
						this.isLoading = false;
					}
				}, error => {
					console.error(error)
				})
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/moveorderlist/moveorderlist.component.js